// assets
import Logo from '@/assets/logo.svg';
import Typography from '@/components/elements/Typography';
import clsx from 'clsx';
import { HTMLAttributes } from 'react';

type Classes = {
  root: string;
  logo: string;
  title: string;
};

export type LogoWithTitleProps = {
  classes?: Partial<Classes>;
} & HTMLAttributes<HTMLDivElement>;

/**
 * @component LogoWithTitle
 */
function LogoWithTitle({ className, classes }: LogoWithTitleProps) {
  const rootClasses = clsx(`flex items-center`, className, classes?.root);
  const logoClasses = clsx(classes?.logo);
  const titleClasses = clsx(`text-gray-400 ml-2 font-light`, classes?.title);
  return (
    <div className={rootClasses}>
      <Logo className={logoClasses} />
      <Typography className={titleClasses}>Botanical</Typography>
    </div>
  );
}

export default LogoWithTitle;
